import { render } from "./SurveyChart.vue?vue&type=template&id=0597dece"
import script from "./SurveyChart.vue?vue&type=script&lang=js"
export * from "./SurveyChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__